import util from 'utils/util';
import statusHelper from 'utils/status-helper'

export const eulaConfirmationRender = function () {
    util.promiseRealSuccess(ajaxCall({
        url: "/ajax/index/eula-confirmation",
        type: 'POST'
    }, 'qm'))
        .done(function () {
            util.doRedirect('/dashboard');
        })
        .fail(function (jqXHR, textStatus, errorThrown, data) {
            statusHelper.displayError(data);
        });
};
